/* eslint-disable */
import { useState, useEffect, useRef } from "react";
import { C, t, fmt$, formatDate } from "../shared/globals.js";

function PriceLadder({ entries, currentPrice, avgPrice }) {
  const [hovered, setHovered] = useState(null);

  const sorted = [...entries].sort((a,b) => {
    const pa = a.shares > 0 ? a.dollars/a.shares : 0;
    const pb = b.shares > 0 ? b.dollars/b.shares : 0;
    return pa - pb;
  });

  const prices = sorted.map(e => e.shares > 0 ? e.dollars/e.shares : 0).filter(p => p > 0);
  if (!prices.length) return null;

  const minP = Math.min(...prices) * 0.92;
  const maxP = Math.max(Math.max(...prices), currentPrice) * 1.06;
  const range = maxP - minP || 1;

  const W = 120, H = 280;
  const PAD = { t:16, b:16, l:16, r:60 };
  const gH = H - PAD.t - PAD.b;
  const cx = PAD.l + (W - PAD.l - PAD.r) / 2;
  const lineX1 = cx - 2, lineX2 = cx + 2;
  const yS = v => PAD.t + gH - ((v - minP) / range) * gH;

  const fmt$ = v => `$${Math.round(v)}`;

  return (
    <div style={{ background:"var(--bg2)", border:"1px solid var(--border)", borderRadius:10, padding:"16px 20px", display:"flex", flexDirection:"column" }}>
      <div style={{ fontFamily:"Montserrat,sans-serif", fontSize:9, fontWeight:700,
        letterSpacing:"0.3em", color:"var(--text4)", marginBottom:14 }}>
        PRICE LADDER
      </div>
      <div style={{ display:"flex", justifyContent:"center", flex:1, alignItems:"center" }}>
        <svg width={W} height={H} style={{ overflow:"visible" }}>
          {/* Vertical spine */}
          <line x1={cx} y1={PAD.t} x2={cx} y2={PAD.t+gH}
            stroke="var(--border)" strokeWidth="2"/>

          {/* Buy dots */}
          {sorted.map((e, i) => {
            const p = e.shares > 0 ? e.dollars/e.shares : 0;
            if (!p) return null;
            const y = yS(p);
            const inProfit = p <= currentPrice;
            const isHov = hovered === i;
            return (
              <g key={e.id || i}
                onMouseEnter={() => setHovered(i)}
                onMouseLeave={() => setHovered(null)}>
                <circle cx={cx} cy={y} r={isHov ? 6 : 4}
                  fill={inProfit ? C.green : C.red}
                  opacity={isHov ? 1 : 0.7}
                  style={{ transition:"r 0.15s, opacity 0.15s", cursor:"default" }}/>
                {isHov && (
                  <text x={cx + 10} y={y + 4} fill="var(--text)" fontSize="9"
                    fontFamily="Montserrat,sans-serif" fontWeight="700">
                    {fmt$(p)}
                  </text>
                )}
              </g>
            );
          })}

          {/* Current price marker */}
          <line x1={cx-16} y1={yS(currentPrice)} x2={cx+16} y2={yS(currentPrice)}
            stroke={C.orange} strokeWidth="2"/>
          <text x={cx+20} y={yS(currentPrice)+4} fill={C.orange} fontSize="9"
            fontFamily="Montserrat,sans-serif" fontWeight="900">
            {fmt$(currentPrice)}
          </text>
          <text x={cx+20} y={yS(currentPrice)+14} fill="var(--text4)" fontSize="7"
            fontFamily="Montserrat,sans-serif" fontWeight="700">CURRENT</text>

          {/* Avg price marker */}
          {avgPrice > 0 && (
            <g>
              <line x1={cx-12} y1={yS(avgPrice)} x2={cx+12} y2={yS(avgPrice)}
                stroke="#a78bfa" strokeWidth="1.5" strokeDasharray="4 2"/>
              <text x={cx+20} y={yS(avgPrice)+4} fill="#a78bfa" fontSize="9"
                fontFamily="Montserrat,sans-serif" fontWeight="900">
                {fmt$(avgPrice)}
              </text>
              <text x={cx+20} y={yS(avgPrice)+14} fill="var(--text4)" fontSize="7"
                fontFamily="Montserrat,sans-serif" fontWeight="700">AVG</text>
            </g>
          )}

          {/* Min/Max labels */}
          <text x={cx+10} y={PAD.t+4} fill="var(--text5)" fontSize="8"
            fontFamily="Montserrat,sans-serif">{fmt$(maxP)}</text>
          <text x={cx+10} y={PAD.t+gH+4} fill="var(--text5)" fontSize="8"
            fontFamily="Montserrat,sans-serif">{fmt$(minP)}</text>
        </svg>
      </div>
    </div>
  );
}

export default PriceLadder;
